import React, { useCallback } from 'react';

import { useAtom } from 'jotai';

import { Button, Modal } from '@consumer-frontend/shared-ui';

import { modalConfigAtom } from '../../store';

import '@consumer-bootstrap/components/modal.scss';
import '@consumer-bootstrap/index.scss';

export const CnuModal: React.FC = () => {
  const [modalconfig, setModalConfig] = useAtom(modalConfigAtom);
  const {
    body,
    modalOnClick,
    primaryText,
    secondaryText,
    show,
    title,
  } = modalconfig;

  const closeModal = useCallback(
    () => setModalConfig((prevConfig) => ({ ...prevConfig, show: false })),
    [setModalConfig],
  );

  const handlePrimaryClick = useCallback(
    () => {
      modalOnClick?.();
      closeModal();
    },
    [modalOnClick, closeModal],
  );

  return (
    <Modal
      show={show}
      onHide={closeModal}
      title={title}
      body={body}
      footer={
        <div className={secondaryText ? 'default' : 'informational'}>
          {secondaryText && (
            <Button variant="outline-primary" onClick={closeModal}>
              {secondaryText}
            </Button>
          )}
          <Button variant="primary" onClick={handlePrimaryClick}>
            {primaryText}
          </Button>
        </div>
      }
    />
  );
};
